export function preventNegative(number: number) {
  return Math.max(number, 0)
}
